<template>
  <img
    ref="image"
    class="max-h-screen w-auto"
    :src="blobUrl"
    @load="loaded"
    v-show="isVisible">
</template>

<script>
import axios from 'axios'

/**
 * Loads the image as a blob and createObjectURL().
 * Set the img tag's src to the object url.
 * Once the image is loaded, revoke the object url (avoid memory leak).
 * Notice that the page can still show the image, but the src blob is no longer valid.
 */
export default {
  data () {
    return {
      blobUrl: null,
      isVisible: false,
    }
  },
  props: {
    src: {
      type: String,
    },
  },
  methods: {
    loaded () {
      if (this.blobUrl) URL.revokeObjectURL(this.blobUrl)
    },
    /**
     * Load an image url as a blob
     */
    async load (src) {
      this.isVisible = false
      const config = { url: src, method: 'get', responseType: 'blob' }
      const response = await axios.request(config)
      return response.data // the blob
    },
  },
  watch: {
    src: {
      immediate: true,
      handler (src) {
        if (!src) return
        this.load(src).then((blob) => {
          this.blobUrl = URL.createObjectURL(blob)
          this.isVisible = true
        })
      },
    },
  },
}
</script>
